import { Select } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

import type { AsanaWorkspaceSelectProps } from "./AsanaWorkspaceSelect.types"

export const AsanaWorkspaceSelect = ({
  workspaces,
  ...props
}: AsanaWorkspaceSelectProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "integrations.asana.form.workspace"
  })

  return (
    <Select
      placeholder={t("placeholder")}
      options={workspaces.map(({ gid, name }) => ({ value: gid, label: name }))}
      {...props}
    />
  )
}
